import { createFileRoute, Outlet } from '@tanstack/react-router'

// Layout wrapper for legacy /documents/* routes (now redirectors)
export const Route = createFileRoute('/_authenticated/_dashboard/documents')({
  component: () => <Outlet />,
})
